export const Images = {
  Folders: {
    SETTINGS: "settings",
    BANNERS: "banners",
    GENERAL: "general",
    PRODUCT_PAGE: "product-page",
    SCAMMERS_LIBRARY: "scammers-library",
  } as const,

  Settings: {
    USER_LAPTOP: "user-laptop",
    PERSON_SCREENS: "person-screens",
    MAGNIFY_GLASS_SCREEN: "magnify-glass-screen",
  },
  Banners: {
    LAPTOP_BIG: "laptop-big",
    LAPTOP: "laptop",
    LAPTOPS: "laptops",
    LOCK: "lock",
    HARDWARE: "hardware",
    CODE: "code",
  } as const,

  ScammersLibrary: {
    WOMAN_SEARCHING: "woman-searching",
  } as const,

  General: {
    Logo: "logo",
    LOGO_DARKER: "logo-darker",
    LOGO_MOBILE: "logo-mobile",
    LOGO_WITH_TEXT: "logo-with-text",
    "404": "404",
  } as const,

  ProductPage: {
    MAGNIFY_GLASS_WOMAN: "magnify-glass-woman",
  } as const,
};

export const Icons = {
  Folders: {
    CONTACT_US: "contact-us",
    PRODUCT_REQUEST_TABLE: "product-request-table",
    APP_BAR_MENU: "app-bar-menu",
    APP_HEADER: "app-header",
    FILE_OPTIONS: "file-options",
    GENERAL: "general",
    PRODUCTS_AND_SERVICES: "products-and-services",
    FILE_TYPES: "file-types",
    UPLOADED_FILES_ACTIONS: "uploaded-files-actions",
    PRODUCT_STATUS: "product-status",
    WALLET_WATCHLIST: "wallet-watchlist",
  } as const,
  CONTACT_US: {
    EMAIL: "email",
    PHONE: "phone",
  },
  ProductStatus: {
    WAITING_FOR_ACTIONS: "waiting-for-actions",
    DONE: "done",
    IN_PROGRESS: "in-progress",
    PENDING: "pending",
  },

  ProductRequestTable: {
    BLOCKCHAIN_ANALYSIS: "blockchain-analysis",
    TRACK_MASTER: "track-master",
    BANK_DISPUTE: "bank-dispute",
    EXCHANGE_DISPUTE: "exchange-dispute",
    WEB_INTELLIGENCE: "web-intelligence",
    CORRESPONDENCE: "correspondence",
  },

  FileTypes: {
    PDF: "pdf",
    DOCUMENT: "document",
    ELSE: "else",
    IMAGE: "image",
    ZIP: "zip",
  } as const,

  UploadedFilesActions: {
    DELETE: "delete",
    VIEW: "view",
    DOWNLOAD: "download",
  } as const,

  AppBarMenu: {
    Correspondence: "correspondence",
    BankDispute: "bank-dispute",
    BlockchainAnalysis: "blockchain-analysis",
    Dashboard: "dashboard",
    ExchangeDispute: "exchange-dispute",
    GeneratePassword: "generate-password",
    IdentityTheftChecker: "identity-theft-checker",
    ProductsAndServices: "products-and-services",
    ScammersLibrary: "scammers-library",
    Settings: "settings",
    TrackMaster: "track-master",
    UploadedFiles: "uploaded-files",
    WalletWatchlist: "wallet-watchlist",
    WebIntelligence: "web-intelligence",
    Payment: "payment",
  } as const,

  AppHeader: {
    Chat: "chat",
    ClockRefresh: "clock-refresh",
    LogoutArrow: "logout-arrow",
    Menu: "menu",
    NotificationBell: "notification-bell",
  } as const,

  FileOptions: {
    Remove: "remove",
    View: "view",
  } as const,

  General: {
    UploadArrow: "upload-arrow",
    ThreeDots: "3-dots",
    Avatar: "avatar",
    UploadFiles: "upload-files",
    WhiteArrowDown: "white-arrow-down",
    WhiteArrowUp: "white-arrow-up",
    WhiteArrowRight: "white-arrow-right",
  } as const,

  ProductsAndServices: {
    Correspondence: "correspondence",
    BankDispute: "bank-dispute",
    BlockchainAnalysis: "blockchain-analysis",
    ExchangeDispute: "exchange-dispute",
    TrackMaster: "track-master",
    WebIntelligence: "web-intelligence",
  } as const,
};
